import React from 'react';
import TeamRoute from 'sections/team/team-route'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import ActiveProjects from 'components/active-projects/active-projects'

import {

} from 'state/actions'

const SinglePersonDetails = props => {
    const {
        allTeams,
        user,
        match,
        loading
    } = props

    const teamList = user.teamIds.map(teamId => {
        return allTeams[teamId]
    })

    return (
        <div className="dashboard-container full-width-on-small-screen">
            <main>
                <div className="left-column">
                    <div className="widget box">
                        <h3>
                            Active projects
                        </h3>
                        <ActiveProjects
                            user={user}
                            loading={loading}
                        />
                    </div>
                </div>
                <div className="right-column">
                    <div className="widget box team-list-mini">
                        <h3>
                            Teams
                        </h3>
                        <TeamRoute 
                            type={'team'}
                            teamList={teamList}
                            canEditTeam={false}
                            path={match.path}
                            isMini={true}
                        />
                    </div>
                </div>
            </main>
        </div>
    )
};


const mapStateToProps = state => {
	return {
		allTeams: state.account.entities.teams
	};
}

export default withRouter(connect(mapStateToProps, {
	
})(SinglePersonDetails))



// WEBPACK FOOTER //
// ./src/components/single-person/single-person-details.jsx